import { useParams } from "react-router-dom";
import { isTaskSaleAdditional } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";
import { PromoCatalogPage } from "@/pages/WorkPlan/Tasks/PromoCatalog/PromoCatalogPage";

const PromoCatalog = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentPoint || !currentTask || !isTaskSaleAdditional(currentTask))
        return <NotFound />;

    return <PromoCatalogPage point={currentPoint} task={currentTask} />;
};

export default PromoCatalog;
